enum SharePageType {
    Event = 'Event',
    ServingOpportunity = 'ServingOpportunity',
}

export default SharePageType;
